<div class="full-screen">
  <div class="centered">
    <form [formGroup]="forgotPasswordForm" novalidate (ngSubmit)="onSubmit()">
      <mat-card class="form-padding" style="border-radius: 40px;">
        <div class="loginImageContainer">
          <img class="loginImage" src="https://stayprivate.com/images/StayPrivate-Logo.svg"/>
        </div>
        <mat-card-title style="color:#888; font-size: 22px; font-weight: 300;">
          Forgotten Password
        </mat-card-title>
        <mat-card-content>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline" class="forgot-input">
                <input matInput placeholder="Enter your email" formControlName="email">
                <mat-error *ngIf="forgotPasswordForm.controls['email'].hasError('required')">
                  Email is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <button mat-flat-button color="primary" [disabled]="!forgotPasswordForm.valid" class="sp-background" style="color: #fff;width: 360px;max-width: 90%;margin:auto;height: 47.5px;border-radius: 24px;" >Request Password Reset</button>
          </div>
          <div class="row">
            <a mat-flat-button routerLink="/login">
              Back to log in
            </a>
          </div>
        </mat-card-content>
      </mat-card>
    </form>
  </div>
</div>


